import { render, staticRenderFns } from "./selectTicket.vue?vue&type=template&id=0c87bcf8&scoped=true"
import script from "./selectTicket.vue?vue&type=script&lang=js"
export * from "./selectTicket.vue?vue&type=script&lang=js"
import style0 from "./selectTicket.vue?vue&type=style&index=0&id=0c87bcf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87bcf8",
  null
  
)

export default component.exports